import { Lesson } from "@/models/Lesson"
import { LessonRecord, LessonRecords } from "@/models/LessonRecord"
import { Schedule } from "@/models/Schedule"
import firebase from 'firebase/app'

class LessonRecordRepository {
  constructor(client) {
    this.collection = client.collection("lessonRecords")
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async put(
    lesson,
    date,
    start,
    end,
    wage
  ) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    lesson.updateSchedule(Schedule.createFromDate(date, start, end)).updateWage(wage)
    const docRef = await this.collection.doc()
    const record = new LessonRecord(
      docRef.id,
      lesson,
      date,
      timestamp,
      timestamp
    )
    const object = record.toObject()
    await docRef.set(object.data)
    const result = await docRef.get()
    return createRecordFromFireStoreData(result.id, result.data(this.snapShotOptions))
  }

  async listByParentId(parentId) {
    const path = new firebase.firestore.FieldPath('lesson', 'data', 'parentId')
    const snapShot = await this.collection.where(path, "==", parentId).get()
    const arr = []
    snapShot.forEach(doc => {
      arr.push(createRecordFromFireStoreData(doc.id, doc.data(this.snapShotOptions)))
    })
    return createRecords(arr)
  }

  async listByTeacherId(teacherId) {
    const path = new firebase.firestore.FieldPath('lesson', 'data', 'teacherId')
    const snapShot = await this.collection.where(path, "==", teacherId).get()
    const arr = []
    snapShot.forEach(doc => {
      arr.push(createRecordFromFireStoreData(doc.id, doc.data(this.snapShotOptions)))
    })
    return createRecords(arr)
  }

  async listById(id) {
    const path = new firebase.firestore.FieldPath('lesson', 'id')
    const snapShot = await this.collection.where(path, "==", id).get()
    const arr = []
    snapShot.forEach(doc => {
      arr.push(createRecordFromFireStoreData(doc.id, doc.data(this.snapShotOptions)))
    })
    return createRecords(arr)
  }

  async update(lessonRecord) {
    lessonRecord.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
    const object = lessonRecord.toObject()
    const docRef = await this.collection.doc(object.id)
    await docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createRecordFromFireStoreData(object.id, data)
  }

  async delete(lessonRecord) {
    return await this.collection.doc(lessonRecord.id).delete()
  }

}

const createLessonFromFireStoreData = (id, data) => {
  return new Lesson(
    id,
    data.teacherId,
    data.parentId,
    data.studentId,
    new Schedule(
      data.schedule.day,
      data.schedule.start,
      data.schedule.end
    ),
    data.wage,
    data.note
  )
}

const createRecordFromFireStoreData = (id, data) => {
  return new LessonRecord(
    id,
    createLessonFromFireStoreData(data.lesson.id, data.lesson.data),
    data.date.toDate(),
    data.createdAt.toDate(),
    data.updatedAt.toDate()
  )
}

const createRecords = (arr) => {
  return new LessonRecords(arr)
}

export { LessonRecordRepository }